// import angular from 'angular';
import ngeoStatemanagerModule from 'ngeo/statemanager/module.js';
import ngeoStatemanagerWfsPermalink from 'ngeo/statemanager/WfsPermalink.js';
import ngeoMiscDebounceModule from 'ngeo/misc/debounce.js';
import ngeoMiscControlModule from 'ngeo/misc/controlComponent';
import ngeoMapModule from 'ngeo/map/component';

export default angular.module('ngeo', [
  ngeoStatemanagerModule.name,
  ngeoStatemanagerWfsPermalink.name,
  ngeoMiscDebounceModule.name,
  ngeoMiscControlModule.name,
  ngeoMapModule.name,
]);
